import { IndeterminateCircleLoader, PROGRESS_CIRCLE_SIZE } from 'cdk-radial';
import { useEffect, useState } from 'react';
import { useIntl, IntlShape } from 'react-intl';
import { useAppDispatch } from 'store/hooks';
import { setDmsPrinterNo, setPrinterId } from '../slice';
import { printerLabel } from '../utils';
import { CheckSequenceDropdowns } from './CheckSequenceDropdown';
import { labels, messages } from './messages';
import {
  StyledPrintOrderDiv,
  StyledPrinterName,
  StyledPrinterLabel,
  StyledPrinterContent,
  StyledEdit,
  StyledOverflowPrinterContent,
  StyledNextAvailableCheckNo,
  StyledOverflowPrinter,
  StyledPrinter,
  StyledIconStatusWarningExclaimationOutlineRound,
  StyledMessage
} from './styled';
import { PrinterContentType } from './types';

export const PrinterContent = ({
  defaultPrinterDetails,
  isPrinterLoading,
  isError
}: PrinterContentType): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const dispatch = useAppDispatch();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const defaultPrinter = defaultPrinterDetails?.find(
    printer => printer?.isDefaultPrinter === true
  );
  const overflowPrinter = defaultPrinterDetails?.find(
    printer => printer?.isAccountingPrinter === true
  );

  useEffect(() => {
    if (defaultPrinter) {
      dispatch(setDmsPrinterNo(defaultPrinter.dmsPrinterNo));
      dispatch(setPrinterId(defaultPrinter.printerId));
    }
  }, [defaultPrinter, dispatch]);

  return (
    <>
      <StyledPrinterContent>
        <StyledPrintOrderDiv>
          {!isEdit && (
            <>
              <StyledPrinterLabel>
                {intl.formatMessage(labels.defaultPrinterLabel)}
              </StyledPrinterLabel>
              {isPrinterLoading ? (
                <StyledPrinterName>
                  <IndeterminateCircleLoader
                    size={PROGRESS_CIRCLE_SIZE.SMALL}
                    hideLabel
                  />
                </StyledPrinterName>
              ) : (
                <StyledPrinterName>
                  {printerLabel(defaultPrinter)}
                </StyledPrinterName>
              )}
            </>
          )}
        </StyledPrintOrderDiv>
        <StyledPrinter>
          <StyledEdit>
            <CheckSequenceDropdowns
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              printerAndCheckData={defaultPrinterDetails || []}
              isError={isError}
            />
          </StyledEdit>
        </StyledPrinter>
      </StyledPrinterContent>
      <StyledPrinterContent>
        <StyledOverflowPrinterContent>
          <StyledOverflowPrinter>
            <StyledPrinterLabel>
              {intl.formatMessage(labels.overflowPrinterLabel)}
            </StyledPrinterLabel>
            {isPrinterLoading ? (
              <StyledPrinterName>
                <IndeterminateCircleLoader
                  size={PROGRESS_CIRCLE_SIZE.SMALL}
                  hideLabel
                />
              </StyledPrinterName>
            ) : (
              <StyledPrinterName>
                {printerLabel(overflowPrinter)}
              </StyledPrinterName>
            )}
          </StyledOverflowPrinter>
        </StyledOverflowPrinterContent>
      </StyledPrinterContent>
      <StyledPrinterContent>
        <StyledMessage>
          <StyledIconStatusWarningExclaimationOutlineRound />
          {intl.formatMessage(messages.printingInProgress)}
        </StyledMessage>
      </StyledPrinterContent>
      <StyledPrinterContent>
        <StyledOverflowPrinterContent>
          <StyledNextAvailableCheckNo>
            <StyledPrinterLabel>
              {intl.formatMessage(labels.nextAvailableCheckLabel)}
            </StyledPrinterLabel>
            {isPrinterLoading ? (
              <StyledPrinterName>
                <IndeterminateCircleLoader
                  size={PROGRESS_CIRCLE_SIZE.SMALL}
                  hideLabel
                />
              </StyledPrinterName>
            ) : (
              <StyledPrinterName>
                {defaultPrinter?.nextCheckNo || ''}
              </StyledPrinterName>
            )}
          </StyledNextAvailableCheckNo>
        </StyledOverflowPrinterContent>
      </StyledPrinterContent>
    </>
  );
};
